'use client'

import { Divider } from '@7f-ui/components/divider/divider'

import { DestinationCard } from 'src/shared/composites/destination-card'
import { DestinationBreadcrumbs } from 'src/shared/composites/destinations/destination-breadcrumbs'

import type { DestinationOverviewItem } from '../_lib/destination-overview-server'

type DestinationOverviewPageClientProps = {
  availableDestinations: DestinationOverviewItem[]
  unavailableDestinations: DestinationOverviewItem[]
}

export function DestinationOverviewPageClient({
  availableDestinations,
  unavailableDestinations,
}: DestinationOverviewPageClientProps) {
  return (
    <div>
      <DestinationBreadcrumbs />

      <section className="bleed-container">
        <div className="flex flex-col gap-12 md:gap-16">
          <div>
            <h1 className="mb-6 font-heading1 sm:mb-12 md:mb-8">Reiseziele</h1>

            <DestinationGrid destinations={availableDestinations} />
          </div>

          <div>
            <h2 className="mb-6 font-heading1 sm:mb-8 sm:font-heading2">
              Bald verfügbare Reiseziele
            </h2>

            <DestinationGrid destinations={unavailableDestinations} unavailable />
          </div>
        </div>
      </section>

      <section className="mt-16 -mb-16 bg-sand">
        <div className="fluid-container">
          <div className="pt-12 pb-8 sm:pt-24 sm:pb-20 xlg:pt-28">
            <h2 className="mb-4 font-heading2 sm:mb-10">Vielfältige Erlebnisse in Deutschland</h2>
            <p className="mb-8 sm:mb-16">
              Von der Ostsee über Berlin bis zu den Alpen finden sich tolle nachhaltige Erlebnisse.
              In der Ostseeregion naturgemäß Aktivitäten auf dem Wasser, aber auch historische
              Stadtführungen. Und auch im alpinen Raum muss auf Wassersport nicht verzichtet werden,
              denn idyllische Seen wie der Eibsee sind perfekte Plätze für Yoga auf dem Paddle-Board
              oder eine Kanu-Tour.
            </p>

            <h2 className="mb-4 font-heading2 sm:mb-10">Vielfältige Erlebnisse in Österreich</h2>
            <p>
              Nicht nur im Winter bieten die österreichischen Berge rund um Kitzbühel und Kössen
              aufregende Aktivitäten in der Natur. Auch im Sommer laden Flüsse wie die Tiroler Ache
              ein zu Canyoning, Rafting und mehr.
            </p>
          </div>
          <Divider className="col-span-12" />
        </div>
      </section>
    </div>
  )
}

function DestinationGrid({
  destinations,
  unavailable,
}: {
  destinations: DestinationOverviewItem[]
  unavailable?: boolean
}) {
  return (
    <div className="grid gap-x-4 gap-y-12 sm:grid-cols-2 md:grid-cols-3">
      {destinations.map(destination => (
        <DestinationCard
          {...destination}
          key={destination.slug}
          unavailable={unavailable}
          headline={destination.name}
        />
      ))}
    </div>
  )
}
